module.exports = __webpack_public_path__ + "static/media/drk_img_01.cd823c8b.jpg";